export const HEADER_HEIGHT_SP = 60;
export const HEADER_HEIGHT_PC = 70;
// タブレットヘッダの高さはPCヘッダに加えて2段組
export const HEADER_HEIGHT_TB = 70 + 38;
